import { __extends } from "tslib";
import * as React from 'react';
import { Button, Dialog as TPAModal, Text, TextTypography as TYPOGRAPHY, } from 'wix-ui-tpa/cssVars';
import { st, classes } from './UserMessage.st.css';
var UserMessage = /** @class */ (function (_super) {
    __extends(UserMessage, _super);
    function UserMessage(props) {
        var _this = _super.call(this, props) || this;
        _this.closeMessage = _this.closeMessage.bind(_this);
        return _this;
    }
    UserMessage.prototype.closeMessage = function () {
        var onRequestClose = this.props.onRequestClose;
        onRequestClose();
    };
    UserMessage.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, isMobile = _a.isMobile, message = _a.message, okLabel = _a.okLabel;
        return (React.createElement(TPAModal, { isOpen: isOpen, onClose: this.closeMessage, notFullscreenOnMobile: true },
            React.createElement("div", { className: classes.root },
                React.createElement(Text, { className: st(classes.messageText), typography: TYPOGRAPHY.runningText }, message),
                React.createElement(Button, { className: st(classes.messageButton), onClick: this.closeMessage, "data-hook": "user-message-action-button", fullWidth: isMobile }, okLabel))));
    };
    return UserMessage;
}(React.PureComponent));
export { UserMessage };
export default UserMessage;
//# sourceMappingURL=UserMessage.js.map